module.exports = __webpack_public_path__ + "static/media/Daenerys Targaryen 2.96fb9c44.jpg";